import { GatewayStatus } from '../types';
export const coreToReactGatewayStatus = (status) => {
    if (!status) {
        return GatewayStatus.UNKNOWN;
    }
    return GatewayStatus[status.toUpperCase()];
};
